import { get } from "lodash";
import { fetchGet } from "../api/fetch";
import { API_DATASTORE } from "../constants/api";

export const fetchDataStoreKey = async (key) => {
  try {
    var res
    if (key === "self_sign_up"){
      res = await fetchGet(`ds/${key}`, API_DATASTORE);
    } else {
      res = await fetchGet(`ds/sys/${key}`, API_DATASTORE);
    }
    
    return get(res, ["data", 0, "value"]);
  } catch (e) {
    console.log(e);
  }
};
